/* Arredamenti Italia 2026: Schnellkauf, Diashow, Markenband */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Schnellkauf und Produktseite: wie product-form.js von Refresh, danach öffnet die Warenkorb-Seitenleiste.
     Ohne Seitenleiste oder bei einem Netzwerkfehler wird das Formular normal abgeschickt (/cart/add). */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ai-quick-add]');
    var drawer = document.querySelector('cart-drawer');
    if (!form || !drawer || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    btn.disabled = true;
    var body = new FormData(form);
    var variantId = Number(body.get('id'));
    body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
    body.append('sections_url', window.location.pathname);
    /* Liegt der Artikel schon im Warenkorb, nicht noch einmal hinzufügen (Bestand meist 1, Shopify prüft erst an der Kasse
       und nennt dort die Stückzahl). Stattdessen die Seitenleiste zeigen; dort ist das Plus auf den Bestand begrenzt. */
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.items.some(function (i) { return i.variant_id === variantId; })) return { aiInCart: true };
        return fetch(form.action, { method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
          .then(function (r) { return r.json(); });
      })
      .then(function (json) {
        /* Schon im Warenkorb oder abgelehnt: Seitenleiste zeigen, keine Meldung mit Stückzahl */
        if (json.aiInCart || json.status) { drawer.open(btn); return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(json);
        btn.classList.add('ai-done');
        setTimeout(function () { btn.classList.remove('ai-done'); }, 1600);
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.disabled = false; });
  });

  /* Diashow: wechselt alle 5 s, hält bei Maus darüber, Fokus, Tab im Hintergrund oder auf Wunsch an */
  document.querySelectorAll('[data-ai-show]').forEach(function (box) {
    var slides = box.querySelectorAll('.ai-sh'), dots = box.querySelectorAll('.ai-d'), ctl = box.querySelector('.ai-sh-ctl'), pp = box.querySelector('.ai-pp');
    if (slides.length < 2 || !pp) return;
    var i = 0, t = null, user = reduce, hover = false;
    function go(n) {
      slides[i].classList.remove('ai-on'); dots[i].classList.remove('ai-on');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('ai-on'); dots[i].classList.add('ai-on');
      [slides[i], slides[(i + 1) % slides.length]].forEach(function (s) { var img = s.querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; });
    }
    function run() { clearInterval(t); if (!user && !hover && !document.hidden) t = setInterval(function () { go(i + 1); }, 5000); }
    function sync() { ctl.classList.toggle('ai-paused', user); pp.setAttribute('aria-label', user ? pp.dataset.labelPlay : pp.dataset.labelPause); run(); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); run(); }); });
    pp.addEventListener('click', function () { user = !user; sync(); });
    box.addEventListener('mouseenter', function () { hover = true; run(); });
    box.addEventListener('mouseleave', function () { hover = false; run(); });
    box.addEventListener('focusin', function () { hover = true; run(); });
    box.addEventListener('focusout', function () { hover = false; run(); });
    document.addEventListener('visibilitychange', run);
    sync();
  });

  /* Produktgalerie: wischen, Pfeile, Vorschaubilder, Zähler */
  document.querySelectorAll('[data-ai-gallery]').forEach(function (g) {
    var track = g.querySelector('.ai-slides'), slides = track.children, ths = g.querySelectorAll('.ai-th');
    var prev = g.querySelector('.ai-prev'), next = g.querySelector('.ai-next'), num = g.querySelector('[data-ai-cnum]');
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    function sync() {
      var i = idx();
      if (num) num.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= slides.length - 1;
      ths.forEach(function (t, k) { t.classList.toggle('ai-on', k === i); if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(sync, 60); }, { passive: true });
    [prev, next].forEach(function (b) { if (b) b.addEventListener('click', function () { go(idx() + Number(b.dataset.step)); }); });
    ths.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.i)); }); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(idx() + 1); if (e.key === 'ArrowLeft') go(idx() - 1); });
  });

  /* EU-Hinweis zur Gewährleistung als Dialog */
  var gd = document.getElementById('AiGarantie');
  if (gd && gd.showModal) {
    document.querySelectorAll('[data-ai-garantie]').forEach(function (b) { b.addEventListener('click', function () { gd.showModal(); }); });
    gd.addEventListener('click', function (e) { if (e.target === gd || e.target.closest('[data-ai-close]')) gd.close(); });
  }

  /* Kaufleiste auf dem Handy: erscheint, sobald der Warenkorb-Knopf nach oben aus dem Bild ist */
  var bar = document.querySelector('[data-ai-buybar]'), mainBtn = document.querySelector('[data-ai-main-cart]');
  if (bar && mainBtn) {
    var bbBtn = bar.querySelector('button'), bbTick = false;
    function syncBar() {
      bbTick = false;
      var show = mainBtn.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('ai-show-bar', show);
      bar.setAttribute('aria-hidden', String(!show));
      bbBtn.tabIndex = show ? 0 : -1;
    }
    window.addEventListener('scroll', function () { if (!bbTick) { bbTick = true; requestAnimationFrame(syncBar); } }, { passive: true });
    syncBar();
  }

  /* Kategorieseite: „Nur sofort lieferbare“ und Sortierung; „Empfohlen“ = Reihenfolge aus Liquid (lieferbare zuerst) */
  document.querySelectorAll('[data-ai-plp]').forEach(function (plp) {
    var grid = plp.querySelector('[data-ai-grid]'), bar = plp.querySelector('[data-ai-plp-bar]');
    if (!grid || !bar) return;
    var cards = Array.prototype.slice.call(grid.children);
    var only = bar.querySelector('[data-ai-only]'), sort = bar.querySelector('[data-ai-sort]'), cnt = bar.querySelector('[data-ai-cnt]');
    var empty = plp.querySelector('[data-ai-empty]');
    bar.querySelector('[data-ai-okcount]').textContent = cards.filter(function (c) { return c.dataset.ok === '1'; }).length;
    function render() {
      var list = cards.slice(), v = sort.value, shown = 0;
      if (v === 'asc') list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      if (v === 'desc') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      list.forEach(function (c) { c.hidden = only.checked && c.dataset.ok !== '1'; if (!c.hidden) shown++; grid.appendChild(c); });
      cnt.textContent = (shown === 1 ? cnt.dataset.one : cnt.dataset.other).replace('[count]', shown);
      empty.hidden = shown > 0;
    }
    only.addEventListener('change', render);
    sort.addEventListener('change', render);
    plp.querySelector('[data-ai-showall]').addEventListener('click', function () { only.checked = false; render(); });
    bar.hidden = false;
    render();
  });

  /* Planung, Ablauf: Bild wechselt mit dem Schritt in der Bildschirmmitte (nur Desktop sichtbar) */
  document.querySelectorAll('[data-ai-steps]').forEach(function (box) {
    var steps = box.querySelectorAll('.ai-step'), imgs = box.querySelectorAll('.ai-vimg');
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = Array.prototype.indexOf.call(steps, e.target);
        steps.forEach(function (s, k) { s.classList.toggle('ai-on', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('ai-on', k === i); });
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach(function (s) { io.observe(s); });
  });

  /* Planung, Räume: Pfeile scrollen die Reihe; Klick auf einen Raum wählt ihn im Formular vor */
  document.querySelectorAll('[data-ai-scroll]').forEach(function (b) {
    var track = document.getElementById(b.getAttribute('aria-controls'));
    b.addEventListener('click', function () {
      var card = track.firstElementChild, step = card ? card.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: Number(b.dataset.aiScroll) * step, behavior: reduce ? 'auto' : 'smooth' });
    });
  });
  document.querySelectorAll('[data-ai-raum]').forEach(function (a) {
    a.addEventListener('click', function () {
      var v = a.dataset.aiRaum, box = document.querySelector('[data-ai-raum-opt="' + v.replace(/"/g, '') + '"]');
      if (box) box.checked = true;
    });
  });

  /* Menüzeile am Handy: aktiven Punkt ins Bild holen, Ränder ausblenden, solange seitlich mehr kommt */
  document.querySelectorAll('.ai-subnav').forEach(function (nav) {
    var cur = nav.querySelector('[aria-current]');
    if (cur && cur.offsetLeft + cur.offsetWidth > nav.clientWidth) nav.scrollLeft = cur.offsetLeft - 16;
    function fade() {
      nav.classList.toggle('ai-fade-l', nav.scrollLeft > 2);
      nav.classList.toggle('ai-fade-r', nav.scrollLeft + nav.clientWidth < nav.scrollWidth - 2);
    }
    nav.addEventListener('scroll', fade, { passive: true });
    window.addEventListener('resize', fade);
    fade();
  });

  /* Cookie-Einstellungen im Fußbereich: nur zeigen, wenn Shopifys Banner da ist */
  var ck = document.querySelector('[data-ai-cookie]');
  if (ck) {
    var showCk = function () { if (window.privacyBanner && window.privacyBanner.showPreferences) { ck.hidden = false; return true; } };
    if (!showCk()) window.addEventListener('load', function () { setTimeout(showCk, 1500); });
    ck.querySelector('button').addEventListener('click', function () { window.privacyBanner.showPreferences(); });
  }

  /* Markenband: läuft nur, wenn die Logos nicht in eine Zeile passen */
  var marquees = document.querySelectorAll('[data-ai-marquee]');
  function sizeMarquees() {
    marquees.forEach(function (m) {
      var set = m.querySelector('.ai-set');
      m.classList.remove('ai-run'); m.classList.add('ai-measure');
      var need = set.scrollWidth > m.clientWidth;
      m.classList.remove('ai-measure');
      if (need && !reduce) { m.classList.add('ai-run'); m.style.setProperty('--dur', Math.round(set.scrollWidth / 32) + 's'); }
    });
  }
  if (marquees.length) {
    sizeMarquees();
    var mq;
    window.addEventListener('resize', function () { clearTimeout(mq); mq = setTimeout(sizeMarquees, 150); });
    window.addEventListener('load', sizeMarquees);
    /* Logos erst kurz vor dem Band laden, danach neu messen (echte Breiten) */
    marquees.forEach(function (m) {
      var imgs = m.querySelectorAll('img[loading="lazy"]');
      imgs.forEach(function (i) { i.addEventListener('load', function () { clearTimeout(mq); mq = setTimeout(sizeMarquees, 150); }); });
      if (!('IntersectionObserver' in window)) { imgs.forEach(function (i) { i.loading = 'eager'; }); return; }
      new IntersectionObserver(function (es, io) {
        if (!es[0].isIntersecting) return;
        imgs.forEach(function (i) { i.loading = 'eager'; });
        io.disconnect();
      }, { rootMargin: '800px 0px' }).observe(m);
    });
  }
})();
